export default {
      id: "ic_acces_rapides-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_acces_rapides-usage",
      toString: function () {
        return this.url;
      }
    }